<ui-switch class="d-flex custom-switch-toggle" [beforeChange]="beforeChange$" [ngModel]="isActive" size="small"></ui-switch>
